import { ConfigProvider, ThemeConfig } from "antd";
import { Locale } from "antd/es/locale";
import en_US from "antd/es/locale/en_US";
import pl_PL from "antd/es/locale/pl_PL";
import ru_RU from "antd/es/locale/ru_RU";
import es_ES from "antd/es/locale/es_ES";
import fr_FR from "antd/es/locale/fr_FR";
import { AppLanguage } from "providers/languages/LocaleProvider";
import { ReactNode } from "react";
import { useSelector } from "react-redux";
import { userSettingsInterfaceLanguageSelector, userSettingsInterfaceSelector } from "state/user/userSettingsSelectors";
import {theme as antTheme} from "antd";
import { layoutSelector } from "state/layoutSlice";
import { INSTANCE_CONFIG } from "config/configHelpers";


//https://ant.design/docs/react/customize-theme#seedtoken
//https://ant.design/theme-editor

const antLocaleConfigs: { [language in AppLanguage]: Locale } = {
    en: en_US,
    pl: pl_PL,
    ru: ru_RU,
    es: es_ES,
    fr: fr_FR
}

const lightTheme = antTheme.defaultAlgorithm;
const darkTheme = antTheme.darkAlgorithm;

const ThemeProvider = (props: {children?: ReactNode}) => {

    const language = useSelector(userSettingsInterfaceLanguageSelector) as AppLanguage;
    const darkMode = useSelector(layoutSelector).darkMode;

    const algo = (theme: any) => {

        //console.log("BEFORE ALGO", theme);
        const afterAlgo = darkMode ? darkTheme(theme) : lightTheme(theme);
       // console.log("AFTER ALGO", afterAlgo);
        return afterAlgo;
    }

    return (
        <>
        <ConfigProvider

            locale={antLocaleConfigs[language]}
            theme={{
                ...INSTANCE_CONFIG.theme,
                //algorithm: userInterfaceSettings?.darkMode ? darkTheme : lightTheme,
                algorithm: algo,
                cssVar: true, // shows css variables insead of pure values;
                components: {
                    Collapse: {
                        headerBg: "var(--ant-color-bg-container)", //by default it's transparent
                    }
                }
            }}
        >
            {props.children}
        </ConfigProvider>
        </>
    )

}

export const LocalThemeProvider = (props: {children?: ReactNode, theme: ThemeConfig}) => {
    return (
        <ConfigProvider
            theme={props.theme}
        >
            {props.children}
        </ConfigProvider>
    )
}

export const LocalThemeWhiteColor = (props: {children?: ReactNode}) => {
    return (
        <LocalThemeProvider theme={{
            token: {
                colorTextBase: "#FFFFFF"
            },
            components: {
                Button: {
                    defaultColor: "var(--ant-color-primary)"
                },
            }
        }}>
            {props.children}
        </LocalThemeProvider>
    )
}


export default ThemeProvider;